var _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoopWithShadow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 48,
    viewBox: "0 0 66 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3358_12525)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled-bracket",
    d: "M1 5.04984C1 2.26089 3.26089 0 6.04983 0H41.3987C44.1876 0 46.4485 2.26089 46.4485 5.04983V7.29741C46.4485 8.98584 45.6047 10.5626 44.1998 11.4991L42.6972 12.5009C41.2923 13.4374 40.4485 15.0142 40.4485 16.7026V27.7974C40.4485 29.4858 41.2923 31.0626 42.6972 31.9991L44.1998 33.0009C45.6047 33.9374 46.4485 35.5142 46.4485 37.2026V40.3987C46.4485 43.1876 44.1876 45.4485 41.3987 45.4485H6.04984C3.26089 45.4485 1 43.1876 1 40.3987V5.04984Z",
    fill: "#C4C4C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inner-arrow",
    d: "M16.6001 10.4502L21.9514 16.0988L16.6001 21.7475",
    stroke: "#1E1E1E",
    strokeWidth: 3.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "inner-arrow",
    d: "M26.39 16.3516H26.5C29.5376 16.3516 32 18.814 32 21.8516V28.6894C32 31.727 29.5376 34.1894 26.5 34.1894H15.5C12.4624 34.1894 10 31.727 10 28.6894V21.7416C10 18.7647 12.4132 16.3516 15.39 16.3516V16.3516H21.66",
    stroke: "#1E1E1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3358_12525)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "filled-bracket",
    d: "M64.4482 40.3984C64.4482 43.1874 62.1874 45.4482 59.3984 45.4482L54.0496 45.4482C51.2606 45.4482 48.9997 43.1874 48.9997 40.3984L48.9997 38.1508C48.9997 36.4624 49.8436 34.8857 51.2484 33.9491L52.751 32.9474C54.1559 32.0108 54.9997 30.4341 54.9997 28.7457L54.9997 17.6508C54.9997 15.9624 54.1559 14.3857 52.751 13.4491L51.2484 12.4474C49.8436 11.5108 48.9997 9.93408 48.9997 8.24565L48.9997 5.04957C48.9997 2.26062 51.2606 -0.000264367 54.0496 -0.000264123L59.3984 -0.00026747C62.1874 -0.000267226 64.4482 2.26062 64.4482 5.04957L64.4482 40.3984Z",
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3358_12525",
    x: 0,
    y: 0,
    width: 47.4485,
    height: 47.4482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3358_12525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3358_12525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3358_12525",
    x: 47.9998,
    y: 0,
    width: 17.4485,
    height: 47.4482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3358_12525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3358_12525",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoopWithShadow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LoopWithShadow.9e2ab466924a1d96f4d529ee81b9d5ab.svg";